import React, { useMemo } from 'react';
import { useRoute } from '@react-navigation/native';

import { GET_STOCK_DELIVERY } from '../../../common/graphql/stockDelivery';
import { ROLE_PERMISSIONS } from '../../../common/constants';
import { useUserContext } from '../../../common/utils/context';

import { EmptyState, Screen } from '../../design/components';

import StockDeliveryDetail from './StockDeliveryDetail';

const StockDeliveryDetailView = () => {
	const route = useRoute();
	const stockDeliveryId = route.params?.id;
	const { hasPermission } = useUserContext();

	const canAccessStockDeliveryDetail = useMemo(() => {
		return Boolean(hasPermission(ROLE_PERMISSIONS.VIEW_STOCK_DELIVERY_DETAIL_PAGE));
	}, [hasPermission]);

	if (!canAccessStockDeliveryDetail) {
		return (
			<Screen>
				<EmptyState icon="lock" title="You do not have access to this stock delivery." />
			</Screen>
		);
	}

	if (!stockDeliveryId) {
		return (
			<Screen>
				<EmptyState title="No stock delivery was selected." />
			</Screen>
		);
	}

	return (
		<Screen scroll={false}>
			<StockDeliveryDetail
				id={stockDeliveryId}
				query={GET_STOCK_DELIVERY}
			/>
		</Screen>
	);
};

export default StockDeliveryDetailView;
